/* eslint-disable */
import $ from "jquery";
import { appInsightTrackEvent } from "./AppInsights";
import { Fragment } from "react";
import { unmountComponentAtNode } from "react-dom";
import ReactDom from "react-dom";
import VGPopUp from "../components/Controls/VGPopUp";
import { AsyncAjaxPost } from "components/Common/AsyncAjaxService";

var isandroidiospro = false;
const ResponseCode = {
  Success: 1000,
  ResponseFail: 1001,
  RecordExists: 1002,
  PartialAuthorize: 5008,
  Fail: 60000
}
const LoginUserType = {
  Customer: 1,
  ServiceProvider: 2,
  ShopAdmin: 4,
  ShopOwnerServiceProvider: 5,
  VagaroAdmin: 6,
  BusinessUser: 0
}

const MobileCallbackTypes = {
  CurrentSelection: 0,
  MobileLink: 6,
  TitleWithBack: 13,
  FilterWithBack: 14,
  DotWithBack: 34,
  TitleOnly: 36,
}

const Site = {
  SiteName: "https://www.vagaro.com/"
}


const MySite = {
  SiteName: "https://mysite.vagaro.com"
}

const VagaroAPIURL = {
  GetMultilocation: "Merchants/mysite/locations",
  SaveMultilocation: "Merchants/mysite/savelocation",
  GetMultilocationPlan: "Merchants/mysite/pricing",
  SaveCustomNickName:"Merchants/mysite/saveurltype"
};

const utils = {
  FormatPrice: (val, CurrencySymbol) => {
    let value = parseFloat(val);
    if (typeof val != undefined && val != null && val != "") {
      if (val < 0) {
        return (
          "(" +
          CurrencySymbol +
          utils.getPositiveValue(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          +
          ")"
        );
      } else {
        return (
          CurrencySymbol +
          value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    } else {
      return CurrencySymbol + "0.00";
    }
  },
  FormatWithoutDecimal: (val, CurrencySymbol) => {
    let value = parseFloat(val);
    if (typeof val != undefined && val != null && val != "") {
      if (val < 0) {
        return (
          "(" +
          CurrencySymbol + utils.getPositiveValue(value).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
          +
          ")"
        );
      } else {
        return (
          CurrencySymbol + value.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
        );
      }
    } else {
      return CurrencySymbol + val;
    }
  },
  Validate: (value) => {
    if (typeof value != undefined && value != null && value != "" && value != 'undefined') {
      return true;
    }
    else
    {
      return false;
    }
  },
  FormatValue: (val) => {
    return ((val).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }))
  },
  InventoryFormatAmount: (val, CurrencySymbol) => {
    if (typeof val != undefined && val != null && val != "") {
      let amt = parseFloat(val);
      return (
        CurrencySymbol +
        amt.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    } else {
      let amt = parseFloat(0);
      return (
        CurrencySymbol +
        amt.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    }
  },
  SetPageTitle: (title) => {
    document.title = "VAGARO" + ((title == undefined || title == null) ? "" : utils.IsFromProApp() ? " " + title : " | " + title);
  },
  appInsightTrack: (businessID, loginUserID, report, objectParameter, Message) => {
    var objdata = {};
    objdata.Name = "React Report";
    objdata.Bid = businessID;
    objdata.Userid = loginUserID;
    objdata.Description = Message;
    objdata.Fname = report;
    objdata.Parameters = JSON.stringify(
      objectParameter
    );
    appInsightTrackEvent(objdata);
  },
  isNullEmptyOrWhiteSpace: function (val) {
    if (typeof (val) == "number") {
      val = val.toString();
    }
    return (val === null || val === undefined || val === "" || val.trim() === "");
  },
  replaceNullOrUndefined: function (val) {
    return (val == null || val == undefined) ? "" : val;
  },
  ShowAlert: (title, body, OpenDialog, focus) => {
    const AlertBody = (body) => {
      return (
        <div>
          {body}
        </div>
      )
    }
    const AlertFooter = () => {
      return (
        <Fragment>          
            <button className="w-button w-button-primary" onClick={() => AlertClose(focus)}>OK</button>          
        </Fragment >
      )
    }
    const AlertClose = (focus) => {
      if (focus === true) {
        $("#forautofocus").focus();
      }
      unmountComponentAtNode(document.getElementById(OpenDialog));
    };
    return ReactDom.render(
      <VGPopUp
        id={"Alert"}
        show={true}
        onHide={AlertClose}
        title={title}
        dialogClassName="vgn-modal-alert vgn-modal-small"
        body={AlertBody(body)}
        footer={AlertFooter()}
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        backdrop={true}
      />,
      document.getElementById(OpenDialog)
    );
  },
  CheckIsFromProApp: (setisandroidiospro) => {
    if (
      navigator != null &&
      navigator.userAgent != null &&
      navigator.userAgent != ""
    ) {
      if (navigator.userAgent.indexOf("VagaroAndroidPhone") > -1 || (navigator.userAgent.indexOf("com.vagaro.iospro") > -1 && navigator.userAgent.indexOf("iPhone") > -1)) {
        $("body").addClass("fromProApp");
        isandroidiospro = true;
        return  setisandroidiospro(true);
  }
      else {
        $("body").removeClass("fromProApp");
        isandroidiospro = false;
        return  setisandroidiospro(false);
      }
    }
    else {
      return setisandroidiospro(false);
    }
  },
  IsFromProApp: () => {
    if (navigator != null && navigator.userAgent != null && navigator.userAgent != "") {
      if (navigator.userAgent.indexOf("VagaroAndroidPhone") > -1 || (navigator.userAgent.indexOf("com.vagaro.iospro") > -1 && navigator.userAgent.indexOf("iPhone") > -1)) {
        $("body").addClass("fromProApp");
        return true;
      }
      else {
        $("body").removeClass("fromProApp");
        return false;
      }
    }
    else {
      return false;
    }
  },
  CallBackGivenToMobileApp: (NativeActionVal, PageTitle, Footer, ReactWebIndex, TimerCount, IsFullLength) => {
    if (
      navigator != null &&
      navigator.userAgent != null &&
      navigator.userAgent != ""
    ) {
      if (NativeActionVal == 6) {        
        var message = '{"message": "","messageType": 0,"screenType": 0,"navType": 0,"action": "6|~|' + PageTitle + '" }';
      }
      else {
        var jsonData = JSON.stringify({ NativeAction: NativeActionVal, Footer: Footer, IsFullLength: IsFullLength, ReactWebIndex: ReactWebIndex }).replace(/\\\"/g, '"').replace(/"/g, "\\\"");
      var message = '{"message": "","messageType": 0,"screenTitle":"' + PageTitle + '","screenType": 0,"navType": 0,"action": "53|~|' + jsonData + '" }';
      }
      var objData = '5006||~||' + message;
      MobileCallbackTypes.CurrentSelection = NativeActionVal;
      if (navigator.userAgent.indexOf("VagaroAndroidPhone") > -1) {
        if (!(window.JSInterface === undefined))
                window.JSInterface.CallWSMethod(objData);
      }
      else if ((navigator.userAgent.indexOf("com.vagaro.iospro") > -1 && navigator.userAgent.indexOf("iPhone") > -1)) {
        setTimeout(() => { window.location = "js-call:myObjectiveCFunction:" + objData }, TimerCount);
  }
    }
  },

  MySiteName: () => {
    return MySite.SiteName
  },
  GetDataInString: (strval,businessid) => {
    if(utils.Validate(strval) && utils.Validate(businessid) && businessid > 0) {
      const splitResult = strval.split(',');
      if(splitResult.includes(businessid.toString()) || splitResult.includes("-1")){
        return true;
  }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }
};
const AddLogInAmplitude = async (logobject) => {
  let data;
  data = {
    PageURL: logobject.PageURL,
    Step: logobject.Step,
    UserAgent: logobject.UserAgent,
    UserID: logobject.UserID,
    BusinessID: logobject.BusinessID,
    MySiteURL: logobject.MySiteURL,
    CountryID: logobject.CountryID
  };
  const VagaroAPIEnum = {
    AddLogInAmplitude: "amplitude/addloginamplitude",
  };
  
  await AsyncAjaxPost(
    VagaroAPIEnum.AddLogInAmplitude,
    data,
    logobject.accessToken,
    function onSuccess(data) {
      try {
          if (data != null && data.data != null && data.data.data != null) {   
          }
      } catch (error) {
        console.log("error");
      }
  },
  function OnError() {
    console.log("error");
  }
  );
}
export { utils, ResponseCode, LoginUserType, Site, MobileCallbackTypes, AddLogInAmplitude, VagaroAPIURL }

